/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import { ArrowForward } from '@material-ui/icons';

const PresentialGroups = ({ presentialGroups }) => {
  const history = useHistory();

  return (
    <Paper
      style={{
        width: '100%',
        flexDirection: 'row',
        padding: '30px',
        height: '100%',
      }}
    >
      <Typography variant="h6" component="p" style={{ marginBottom: '15px' }}>Group distribution: </Typography>
      <Alert severity="info" icon={false} style={{ marginBottom: '10px' }}>
        You can find here the group distribution, the trainer assigned to your group,
        as well as your Zoom link if your classes are held remotely.
      </Alert>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => history.push('/group')}
        disableElevation
        startIcon={<ArrowForward />}
      >
        Go to group(s)
      </Button>
      {/* ))} */}
    </Paper>
  );
};

export default PresentialGroups;
